import React, {ReactElement} from 'react';

import NavigationSubcategory from '~/src/components/navigation/subcategory/NavigationSubcategory';
import TeaserUI from '~/src/components/teaser/Teaser';
import Link from '~/src/components/link/Link';
import Boomerang from '~/src/components/svg/general/Boomerang';
import {SidelineItem} from '~/src/components/sidelineItem/SidelineItem';

import {TeaserLayoutProps} from '~/src/components/teaser/layout/default/TeaserLayoutDefault';
import {getAdUnitName} from '~/src/utilities/helpers/ad';
import {createFormat} from '~/src/utilities/feed/format';
import {TeaserFormat, AdFormat} from '~/src/utilities/constants/formats';
import {SectionLayout} from '~/src/utilities/constants/layout';
import {TeaserTypes} from '~/src/utilities/constants/types';
import {getCategoryUrl} from '~/src/utilities/helpers/link';
import {createNavigationTracker} from '~/src/utilities/tracking/gtm';
import {slugify} from '~/src/utilities/helpers/string';
import {Teaser, TeaserAd} from '~/src/types/data/teaser';

import css from './TeaserLayoutNews.module.scss';

const isAd = (teaser: Teaser): teaser is TeaserAd => teaser.type === 'ad';

const TeaserLayoutNews = ({
    children,
    title,
    showTitle = false,
    layout,
    pointerCategoryID,
    sortID,
    fullUrlPath,
    isPlaceholder = false,
    elements,
    subtype,
    getNextSideline
}: TeaserLayoutProps) => {
    const teasers = React.Children.toArray(children) as ReactElement[];

    if (!isPlaceholder) {
        for (let i = 0; i < elements.length; i++) {
            const element = elements[i];
            if (element.format?.primaryGrid === TeaserFormat.TEASER_LARGE) {
                const index = teasers.findIndex((teaser) => 'id' in element && teaser.props.id === element.id);
                const adUnit = subtype === 'category' ? `inside-quarter-${slugify(fullUrlPath!)}` : `inside-quarter`;
                teasers.splice(index + 1, 0, <SidelineItem adUnit={adUnit} getNextSideline={getNextSideline} />);

                if (i === 0 && sortID === 0) {
                    teasers.splice(
                        i + 2,
                        0,
                        <TeaserUI
                            type={TeaserTypes.AD}
                            key="inside_full_top"
                            adUnitName={getAdUnitName('inside-full-top')}
                            format={createFormat(AdFormat.INSIDE_FULL_TOP)}
                        />
                    );
                }
            }
        }
    }

    return (
        <React.Fragment>
            {showTitle && (
                <div className={css.titleHeader}>
                    <h1 className={css.title}>
                        {fullUrlPath ? (
                            <Link
                                className={css.titleLink}
                                href={getCategoryUrl(fullUrlPath)}
                                onClick={pointerCategoryID ? createNavigationTracker(4, title, pointerCategoryID) : null}
                            >
                                {title}
                                <Boomerang />
                            </Link>
                        ) : (
                            title
                        )}
                    </h1>

                    {layout === SectionLayout.SUB_NAVIGATION && pointerCategoryID && (
                        <NavigationSubcategory categoryId={pointerCategoryID} inTeaserSection={true} />
                    )}
                </div>
            )}

            <div className={css.teasers}>{teasers}</div>
        </React.Fragment>
    );
};

export default TeaserLayoutNews;
